const config = {
    'SERVICE_URL_PREFIX': 'https://corpushub-test.kuaiman.com/api/v1',
}

export default config;
